/**
 * talents grid functionality
 */

export function talentGrid() {
    function setupGrid() {
        const grid = document.querySelector('.talents__grid');
        
        // Exit if no grid element found
        if (!grid) {
            return;
        }
        
        const cards = [...grid.querySelectorAll('.talent-card')];

        function getColumnCount() {
            const width = window.innerWidth;
            if (width <= 500) return 1;
            if (width <= 800) return 2;
            if (width <= 1285) return 3;
            if (width <= 1600) return 4;
            return 5;
        }

        function distributeCards() {
            const colCount = getColumnCount();
            
            const columns = Array.from({ length: colCount }, () => []);

            // Distribute cards into columns
            cards.forEach((card, i) => {
                columns[i % colCount].push(card.outerHTML);
            });

            // Update grid class and content
            grid.className = `talents__grid cols-${colCount}`;
            grid.innerHTML = columns
                .map(col => `<div class="column">${col.join('')}</div>`)
                .join('');
        }

        // Run on load and resize
        distributeCards();
        window.addEventListener('resize', distributeCards);
    }
    
    // Execute immediately if DOM is ready, otherwise wait
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupGrid);
    } else {
        setupGrid();
    }
}

// Execute immediately when script loads (if on talents page)
if (document.querySelector('.talents__grid')) {
    talentGrid();
}